import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Persistent guest fingerprint (spec fork 25 fix « tickets dupliqués »).
// Stored in a dedicated localStorage key, separate from the JWT, so it
// survives any /auth/me transient failure that would otherwise purge the
// token and force the next /tickets/anonymous call to spawn a new guest.
const GUEST_FP_KEY = "bypassgo_guest_fingerprint";
function getOrCreateGuestFingerprint() {
  try {
    let fp = localStorage.getItem(GUEST_FP_KEY);
    if (!fp) {
      fp = (crypto?.randomUUID && crypto.randomUUID())
        || `fp-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem(GUEST_FP_KEY, fp);
    }
    return fp;
  } catch {
    return null;
  }
}

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("bypassgo_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  const fp = getOrCreateGuestFingerprint();
  if (fp) cfg.headers["X-Guest-Fingerprint"] = fp;
  return cfg;
});

export default api;
